<template>
  <v-app :theme="currentTheme">
    <NavBar v-if="!hideAppChrome" />
    <!-- Exibe a SideBar apenas se usuário estiver logado e a tela for maior que 670px -->
    <SideBar v-if="user && user.id && !isMobile && !hideAppChrome" />
    <CookieConsentBanner />
    <router-view />
  </v-app>
</template>

<script>
import NavBar from "@/layout/Navbar.vue";
import SideBar from "@/layout/Sidebar.vue";
import { mapState, mapActions } from "vuex";
import CookieConsentBanner from "@/components/common/CookieConsentBanner.vue";

export default {
  name: "App",
  components: { NavBar, SideBar, CookieConsentBanner },
  data() {
    return {
      isMobile: false,
    };
  },
  async created() {
    this.handleResize();
  },
  mounted() {
    window.addEventListener("mm:auth:logout", async () => {
      await this.$store.dispatch("logout");
      this.$router.replace("/login");
    });
    window.addEventListener("resize", this.handleResize);
    this.syncRootOffsetClass();
    this.$watch(
      () => this.$route.fullPath,
      () => {
        this.syncRootOffsetClass();
        window.scrollTo(0, 0);
      },
    );
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this.syncRootOffsetClass(false);
  },
  computed: {
    ...mapState(["user"]),
    currentTheme() {
      return this.$store.state.theme;
    },
    hideAppChrome() {
      return this.$route.meta?.hideAppChrome === true;
    },
  },
  watch: {
    hideAppChrome: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.syncRootOffsetClass());
      },
    },
  },
  methods: {
    ...mapActions(["loginUserByToken"]),
    handleResize() {
      this.isMobile = window.innerWidth <= 670;
    },
    syncRootOffsetClass(forceState) {
      const root = document.getElementById("app");

      if (!root) return;

      const shouldHideOffset =
        typeof forceState === "boolean" ? forceState : this.hideAppChrome;

      root.classList.toggle("app-shell--bare", shouldHideOffset);
    },
  },
};
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}

#app.app-shell--bare {
  margin-top: 0;
}
</style>
